<script>
import ValidatesUsers from "./mixins/validates-users";
import toasts from "../../mixins/toasts";

export default Vue.extend({
  props: {
    user: {
      type: Object,
      required: true
    },
    emailConfirmed: Boolean
  },
  mixins: [ValidatesUsers, toasts],
  data() {
    return {
      data: _.clone(this.user),
      original: _.clone(this.user),
      loading: false,
      modified: false,
      canSendEmail: true,
      emailSent: false,
      emailChanged: false,
      currentTab: 0,
      tabMap: ["login", "email", "password"]
    };
  },
  computed: {
    loginFieldMessage() {
      if (this.errors.has("login.login")) {
        return this.errors.first("login.login");
      } else if (_.trim(this.data.login) == this.data.alias) {
        return "Логин совпадает с Вашим идентификатором пользователя.";
      } else if (_.trim(this.data.login) == this.original.login) {
        return "У Вашего профиля уникальный логин.";
      }
    },
    loginFieldType() {
      if (this.errors.has("login.login")) {
        return "is-danger";
      } else if (_.trim(this.data.login) == this.data.alias) {
        return "is-warning";
      }

      return "is-success";
    },
    emailFieldMessage() {
      if (this.errors.has("email.email")) {
        return this.errors.first("email.email");
      } else if (_.trim(this.data.email) == this.original.email) {
        if (!this.data.email_confirmed) {
          return "Данный почтовый ящик не подтвержден.";
        }
        return "Данный почтовый ящик подтверждён.";
      }
    },
    emailFieldType() {
      if (this.errors.has("email.email")) {
        return "is-danger";
      } else if (_.trim(this.data.email) == this.original.email) {
        if (!this.data.email_confirmed) {
          return "is-warning";
        }
        return "is-success";
      }
    },
    emailConfirmedNotification() {
      return this.emailConfirmed && !this.emailChanged;
    },
    sameEmail() {
      return _.trim(this.data.email) == this.original.email;
    },
    tabName() {
      return this.tabMap[this.currentTab];
    }
  },
  methods: {
    modify() {
      this.modified = true;
    },
    onTabsChange(index) {
      this.$router.replace({
        query: {
          tab: this.tabMap[index]
        }
      });
    },
    submit() {
      if (!this.modified && this.tabName != "email") {
        return;
      }

      this.modified = false;
      this.loading = true;
      let loading = this.$loading.open();

      this.$validator.validate(`${this.tabName}.*`).then(valid => {
        if (!valid) {
          this.loading = false;
          loading.close();
          return;
        }

        axios
          .post(
            `/api/users/${this.data.id}/security/${this.tabName}`,
            this.data
          )
          .then(response => {
            if (this.tabName != "email") {
              this.toast("success", response.data.message, {
                duration: 4500
              });
              _.delay(() => {
                location.reload();
              }, 5000);
            } else {
              this.emailSent = true;
              this.loading = false;
              loading.close();
            }
          })
          .catch(error => {
            switch (error.response.status) {
              case 403: {
                this.toast("error", "Указанный текущий пароль неправильный");
                break;
              }
              case 429: {
                switch (this.tabName) {
                  case "email": {
                    this.toast(
                      "warning",
                      "Письмо для подтверждения можно отправлять каждые 15 минут"
                    );
                    this.canSendEmail = false;
                    _.delay(_ => {
                      this.canSendEmail = true;
                    }, 1000 * 60 * 10); // 10 minutes
                    break;
                  }
                }
                break;
              }
              default: {
                this.toast("error", "@unexpected", error);
                break;
              }
            }
            this.data.current_password = null;
            this.data.current_password_confirmation = null;
            this.data.new_password = null;
            this.data.new_password_confirmation = null;
            this.loading = false;
            loading.close();
          });
      });
    }
  },
  created() {
    this.currentTab = Math.max(
      0,
      _.indexOf(this.tabMap, this.$route.query.tab)
    );
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/users/Security.vue